<app-label [label]="name">
  <div class="value__wrapper">
    <app-parse-links class="text_size-{{ size }}" [value]="value"></app-parse-links>
  </div>
</app-label>
